import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }
`;

export const InfoAtendimento = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TarefaDia = styled.div`
  flex: 1.5;
  margin-right: 20px;
  h4 {
    font-size: 20px;
    color: #eee;
  }
`;

export const InfoTarefas = styled.div`
  margin-top: 20px;
  background: #1f2232;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  h4 {
    font-size: 16px;
    padding-right: 40px;
    color: ${props => (props.danger ? 'red' : '#EEE')};

    span {
      margin-right: 5px;
      font-weight: bold;
      font-size: 18px;
    }
  }

  & + div {
    h4 {
      border-left: 1px solid #eee;
      padding-left: 40px;
    }
  }
`;

export const Tarefas = styled.div`
  flex: 1;
  margin-top: 60px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 10px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Dia = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  h4 {
    color: #eee;
    font-size: 16px;
  }
`;

export const Blocos = styled.ul`
  margin-top: 20px;
  overflow: hidden;
`;

export const Bloco = styled.div`
  flex: 1;
  background: ${props => (props.atrasada ? '#3A0104' : '#1f2232')};
  padding: 20px 10px 20px 20px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  width: ${props => (props.atrasada ? '100%' : '100%')};

  ${props =>
    props.atrasada &&
    css`
      & + div {
        margin-top: 10px;
      }
    `};
`;

export const BlocosDia = styled.ul`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  overflow: hidden;

  /* & + div {
    margin-top: 10px;
  } */
`;

export const DadosAtendimento = styled.div`
  margin-left: 50px;

  button {
    background: #00b81b;
    border: 0;
    padding: 8px 15px;
    margin: 10px 0;
    border-radius: 4px;
    color: #eee;
  }
`;

export const DadosPessoais = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Dados = styled.div`
  margin-bottom: 20px;
  h4 {
    font-size: 14px;
  }

  span {
    color: #eee;
    font-size: 12px;
    margin-top: 5px;
  }
`;

export const InfoTentativas = styled.div`
  p {
    display: flex;
    align-items: center;
    color: #eee;
    font-size: 12px;

    span {
      border: 1px solid #eee;
      padding: 0 5px 2px 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    svg {
      margin-right: 5px;
    }

    & + p {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
`;

export const Atendimento = styled.div`
  p {
    color: #eee;
    font-size: 12px;

    & + p {
      margin-top: 5px;
    }
  }
`;

export const BtCarregar = styled.button`
  background: none;
  border: none;
  color: #626ed4;
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin: 20px auto;
  transition: 0.2s text-decoration ease-in;
  &:hover {
    text-decoration: underline;
  }
`;

// Estilos dos atrasados

export const Atrasadas = styled.div`
  /* margin-left: 10px; */
  h4 {
    color: #eee;
    font-size: 16px;
  }
`;
